import React, { useEffect, useState, Suspense } from 'react';

const LazyToaster = React.lazy(async () => {
  const mod = await import('react-hot-toast');
  return { default: mod.Toaster } as any;
});

const DeferredToaster: React.FC = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onLoad = () => setTimeout(() => setShow(true), 1500);
    if (document.readyState === 'complete') onLoad();
    else window.addEventListener('load', onLoad, { once: true });
    return () => window.removeEventListener('load', onLoad);
  }, []);
  if (!show) return null;
  return (
    <Suspense fallback={null}>
      <LazyToaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: { background: '#363636', color: '#fff' },
          success: { duration: 3000, iconTheme: { primary: '#4ade80', secondary: '#fff' } },
          error: { duration: 5000, iconTheme: { primary: '#ef4444', secondary: '#fff' } },
        }}
      />
    </Suspense>
  );
};

export default DeferredToaster;

